import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'replaceNullOrUndefinedTo',
  standalone: false
})
export class ReplaceNullOrUndefinedToPipe implements PipeTransform {
  transform(value: unknown, replacement: string | number): unknown {
    if (
      typeof value === 'undefined' ||
      value === null ||
      ((typeof value === 'string' || typeof value === 'number') &&
        value.toString().trim().length === 0)
    ) {
      return replacement;
    }

    return value;
  }
}
